import type { WorkspaceResponseV2 } from '@emma/api_client/types';
import { Flex } from '@lego/klik-ui';
import { FleetTable } from '@/components/fleet';
import { VulnerabilitiesTable } from '@/components/vulnerabilities/VulnerabilitiesTable';
import { WorkspaceDetails, WorkspaceDeviceTable } from '@/components/workspace';

type Props = {
  workspace: WorkspaceResponseV2;
  isLoading?: boolean;
};

export const WorkspaceHomeSubPage = (props: Props) => {
  return (
    <Flex direction="column" gap={8} mb={4}>
      <WorkspaceDetails isLoading={props.isLoading} workspace={props.workspace} />
      <WorkspaceDeviceTable workspace={props.workspace} />
      <FleetTable workspace={props.workspace} />
      <VulnerabilitiesTable workspace={props.workspace} />
    </Flex>
  );
};
